import React from "react";
import PrivateLayout from "components/PrivateLayout";
import Heading from "components/Heading";
import Separator from "components/Separator";
import Card from "components/Card";
import CustomTableForm from "components/custom-table/CustomTableForm";

function ABSTableConfigurationScreen({ history }) {
  return (
    <React.Fragment>
      <PrivateLayout>
        <Heading size="md">ABS - Table Configuration</Heading>
        <Separator />
        <Card>
          <CustomTableForm />
        </Card>
      </PrivateLayout>
    </React.Fragment>
  );
}

export default ABSTableConfigurationScreen;
